<!-- {{Resdatas|json}} -->
<div class="card pt-0 mb-5">
  <div class="card-body">
    <form (ngSubmit)="onSubmit(merchantMDRform.value)" [formGroup]="merchantMDRform">
      <div>
        <div class="row hidden">
          <div class="col-sm-12">
            <div class="mb-3">
              <label class="form-label">Entity ID <span aria-hidden="true" class="symbol required"
                  style="color:red;">*</span></label>
              <ng-select formControlName="merchantId" (keyup.enter)="loadDatabyMid()" (click)="loadDatabyMid()"
                placeholder="merchantId">
                <ng-option *ngFor="let merchant of Resultdata" [value]="merchant.MerchantId">
                  {{merchant.merchant_name}} ({{merchant.MerchantId}})
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <ngb-accordion #acc="ngbAccordion" [closeOthers]="closeOthers" [activeIds]="activeIds"
          [style]="highlight ? 'border: 1px red': 'border: none'">
          <ngb-panel #accPan title="MoP Setup" id="pan-1">
            <ng-template ngbPanelContent>
              <div class="row">
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Acquirer <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <select class="form-select" aria-label="Default select example" formControlName="acquirerId" id="acquirerId"
                      (change)="onAquirerChnage($event)" [ngClass]="{'is-invalid': isForm1Submitted && form1.acquirerId.errors}"
                      title="Select Acquirer"  (focus)="fun('acquirerId')" (focusout)="funover('acquirerId')">
                      <option value="" disabled class="drop" title="Select Acquirer">Select Acquirer
                      </option>
                      <option *ngFor="let service of Resdata" [title]="service.FieldText" [value]="service.FieldValue">
                        {{service.FieldText}}</option>
                    </select>

                  </div>
                </div><!-- Col -->
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Payment Type <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <select class="form-select" aria-label="Default select example" formControlName="paymentType" id="paymentType"
                      (change)="onPaymentTypeChange($event)"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.paymentType.errors}"
                      title="Select Payment Type"  (focus)="fun('paymentType')" (focusout)="funover('paymentType')">
                      <option value="" class="drop" disabled selected title="Select Payment Type">Payment Type
                      </option>
                      <option [disabled]="!(paymentType)" *ngFor="let instrument of Resdatas"
                        [value]="instrument.FieldValue" [title]="instrument.FieldText">
                        {{instrument.FieldText}}</option>
                    </select>
                    
                  </div>
                </div>
                <!-- Col -->

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Mop Type <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span>
                    </label>
                    <select (change)="resetMDR('mdrType')" class="form-select" aria-label="Default select example"
                            formControlName="mopType"  id="mopType" [ngClass]="{'is-invalid': isForm1Submitted && form1.mopType.errors}"
                            title="Select Mop Type"   (focus)="fun('mopType')" (focusout)="funover('mopType')">
                      <option value="" disabled class="drop" title="Select Aggr MDR">Select Mop Type</option>
                 
                      <option *ngFor="let mop of Resbank"  [value]="mop.FieldValue" [title]="mop.FieldText">
                      {{mop.FieldText}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Currency <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span>
                    </label>
                    <select  class="form-select" aria-label="Default select example"
                            formControlName="currency"  id="currency" [ngClass]="{'is-invalid': isForm1Submitted && form1.currency.errors}"
                            title="Select Currency"   (focus)="fun('currency')" (focusout)="funover('currency')">
                      <option value="" disabled class="drop" title="Select Currency">Select Currency</option>               
                      <option *ngFor="let currencyadata of currencyData" [title]="currencyadata.name" [value]="currencyadata.code">
                        {{currencyadata.name}}</option>
                    </select>
                  </div>
                </div>

                <!-- Col -->
              </div>
              <div class="row">
          
                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">Minimum Amount <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="Min Amount"
                      formControlName="minAmt" [ngClass]="{'is-invalid': isForm1Submitted && form1.minAmt.errors}"
                      (keypress)="onlyNumbersAllowed($event)">
                     <div *ngIf="isForm1Submitted && form1.minAmt.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                    <div *ngIf="!mindatadis" class="text-danger mt-1">
                      Min amount should more the 0
                    </div>

                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">Maximum Amount <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="Max Amount"
                      formControlName="maxAmt" [ngClass]="{'is-invalid': isForm1Submitted && form1.maxAmt.errors}"
                      (keypress)="onlyNumbersAllowed($event)">
                     <div *ngIf="isForm1Submitted && form1.maxAmt.errors?.required" class="invalid-feedback">
                        Please fill this field
                    </div> 

                    <div *ngIf="!maxdatadis" class="text-danger mt-1">
                      Max amount should be greater then min Amount
                    </div>
                  </div>
                </div>
                <!--Col-->
                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">Card Type <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span>
                    </label>
                    <select class="form-select" aria-label="Default select example"
                            formControlName="cardType"  id="cardType" [ngClass]="{'is-invalid': isForm1Submitted && form1.cardType.errors}"
                            title="Select Mop Type"   (focus)="fun('cardType')" (focusout)="funover('cardType')">
                      <option value="" disabled class="drop" title="Select Card Type">Select Card Type</option>

                      <option *ngFor="let cardType of cardTypeList"  [value]="cardType.FieldValue" [title]="cardType.FieldText">
                      {{cardType.FieldText}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- Col -->
                <!-- Col -->
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Start Date <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <div class="mb-3">
                      <div class="input-group">
                        <input (keydown)="noKeyInput($event)"  [min]="todayDate"
                          (change)="changeDate(merchantMDRform.controls['startDate'].value)" type="date"
                          class="form-control" placeholder="dd-mm-yyyy" formControlName="startDate"
                          [ngClass]="{'is-invalid': isForm1Submitted && form1.startDate.errors}"
                          >
                         <div *ngIf="isForm1Submitted && form1.startDate.errors?.required"
                            class="invalid-feedback">
                            Please fill this field
                        </div> 

                      </div>
                    </div>
                  </div>
                </div>
                <!--Col -->
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">End Date <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <div class="mb-3">
                      <div class="input-group">
                        <input (keydown)="noKeyInput($event)"  [min]="todayDate" type="date" class="form-control" placeholder="dd-mm-yyyy"
                          formControlName="endDate" [ngClass]="{'is-invalid': isForm1Submitted && form1.endDate.errors}"
                          (change)="changeEndDate(merchantMDRform.controls['endDate'].value)">
                         <div *ngIf="isForm1Submitted && form1.endDate.errors?.required"
                            class="invalid-feedback">
                            Please fill this field
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
                <!--Col-->
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">MID <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input type="text" (keypress)="keyPressNumbers($event)" autocomplete="new-password" maxlength="100" class="form-control" placeholder="MID" formControlName="mid"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.mid.errors}"
                      >
                     <div *ngIf="isForm1Submitted && form1.mid.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>
                <!--Col-->
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">TID <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input type="text" (keypress)="keyPressNumbers($event)" autocomplete="new-password"  maxlength="100" class="form-control" placeholder="TID" formControlName="tid" 
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.tid.errors}"
                      >
                     <div *ngIf="isForm1Submitted && form1.tid.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">Enc Key <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input type="text" (keypress)="keyPressNumbers($event)" autocomplete="new-password" maxlength="100" class="form-control" placeholder="encKey" formControlName="encKey"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.encKey.errors}">
                     <div *ngIf="isForm1Submitted && form1.encKey.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>
                <!--Col-->
                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF1 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF1" formControlName="adf1">
                  </div>
                </div>
                 <!--Col-->
                 <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF2 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF2" formControlName="adf2">
                  </div>
                </div>
              </div>
              <!--Row-->
              <div class="row">
                   <!--Col-->
                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF3 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF3" formControlName="adf3">
                  </div>
                </div>
                <!--Col-->
                 <!--Col-->
                 <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF4 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF4" formControlName="adf4">
                  </div>
                </div>
                 <!--Col-->
                 <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF5 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF5" formControlName="adf5">
                  </div>
                </div>
              </div>
              <!--Row-->
              <div class="row">
                 <!--Col-->
                 <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF6 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF6" formControlName="adf6">
                  </div>
                </div>
                 <!--Col-->
                 <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF7 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF7" formControlName="adf7">
                  </div>
                </div>
                 <!--Col-->
                 <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">ADF8 </label>
                    <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF8" formControlName="adf8">
                  </div>
                </div>
              </div>

              <!--Row-->
              <div class="row">
                <!--Col-->
                <div class="col-sm-4">
                 <div class="mb-3">
                   <label class="form-label">ADF9 </label>
                   <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF9" formControlName="adf9">
                 </div>
               </div>
                <!--Col-->
                <div class="col-sm-4">
                 <div class="mb-3">
                   <label class="form-label">ADF10 </label>
                   <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF10" formControlName="adf10">
                 </div>
               </div>
                <!--Col-->
                <div class="col-sm-4">
                 <div class="mb-3">
                   <label class="form-label">ADF11 </label>
                   <input type="text" autocomplete="new-password" maxlength="100" class="form-control" placeholder="ADF11" formControlName="adf11">
                 </div>
               </div>
             </div>
            </ng-template>

          </ngb-panel>

          <ngb-panel id="pan-2" title="MDR Setup">
            <ng-template ngbPanelContent>


              <div class="row">
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">MDR Type <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>

                    <select (change)="resetMDR('mdrType')" class="form-select" aria-label="Default select example"
                      formControlName="mdrType"  id="mdrType" [ngClass]="{'is-invalid': isForm1Submitted && form1.mdrType.errors}"
                      title="Select Aggr MDR"   (focus)="fun('mdrType')" (focusout)="funover('mdrType')">
                      <option value="" disabled class="drop" title="Select MDR">Select MDR</option>
                      <option value="1" title="Percentage">Percentage</option>
                      <option value="2" title="Flat">Flat</option>
                    </select>
                     <div *ngIf="isForm1Submitted && form1.mdrType.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>
                
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">MDR <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input #aggrMdr type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="MDR"
                      formControlName="mdr" [ngClass]="{'is-invalid': isForm1Submitted && form1.mdr.errors}"
                      appTwoDigitDecimaNumber
                       (keypress)="onlyNumbersAllowed($event)">
                    <div *ngIf="isForm1Submitted && form1.mdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Min MDR</label>
                    <input #minMdr type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="Min MDR"
                      formControlName="minMdr" [ngClass]="{'is-invalid': isForm1Submitted && form1.minMdr.errors}"
                      appTwoDigitDecimaNumber
                       (keypress)="onlyNumbersAllowed($event)">
                     <div *ngIf="isForm1Submitted && form1.minMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>

                </div>
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Max MDR</label>
                    <input #maxMdr type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="Max MDR"
                      formControlName="maxMdr" [ngClass]="{'is-invalid': isForm1Submitted && form1.maxMdr.errors}"
                      appTwoDigitDecimaNumber
                       (keypress)="onlyNumbersAllowed($event)">
                    <div *ngIf="isForm1Submitted && form1.maxMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>

              </div>
              <!-- Bank MDR -->
              <div class="row">
                <div class="col-sm-3">

                  <div class="mb-3">
                    <label class="form-label"> Bank MDR Type <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>

                    <select (change)="resetMDR('bankMdrType')" class="form-select" aria-label="Default select example"
                      formControlName="bankMdrType" id="bankMdrType"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.bankMdrType.errors}" title="Select Bank MDR" (keypress)="onlyNumbersAllowed($event)"
                      (focus)="fun('bankMdrType')" (focusout)="funover('bankMdrType')">
                      <option value="" disabled class="drop" title="Select Bank MDR">Select Bank MDR</option>
                      <option value="1" title="Percentage">Percentage</option>
                      <option value="2" title="Flat">Flat</option>
                    </select>
                     <div *ngIf="isForm1Submitted && form1.bankMdrType.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  
                  </div>
                </div>
                
                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Bank MDR <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input #baseRate type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="Bank MDR"
                      formControlName="bankMdr" [ngClass]="{'is-invalid': isForm1Submitted && form1.bankMdr.errors}"
                      appTwoDigitDecimaNumber
                       (keypress)="onlyNumbersAllowed($event)">
                     <div *ngIf="isForm1Submitted && form1.bankMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Min Bank MDR</label>
                    <input #minBaseRate type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="Min Bank MDR"
                      formControlName="bankMinMdr"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.bankMinMdr.errors}" appTwoDigitDecimaNumber
                       (keypress)="onlyNumbersAllowed($event)">
                     <div *ngIf="isForm1Submitted && form1.bankMinMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label class="form-label">Max Bank MDR</label>
                    <input #minBaseRate type="text" autocomplete="new-password" maxlength="10" class="form-control" placeholder="Max Bank MDR"
                      formControlName="bankMaxMdr"     appTwoDigitDecimaNumber
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.bankMaxMdr.errors}"
                       (keypress)="onlyNumbersAllowed($event)">
                     <div *ngIf="isForm1Submitted && form1.bankMaxMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-sm-3">

                  <div class="mb-3">
                    <label class="form-label">Is Surcharge <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>

                       

                    <select class="form-select" aria-label="Default select example"
                      formControlName="surcharge" id="surcharge" [ngClass]="{'is-invalid': isForm1Submitted && form1.surcharge.errors}"
                      title="Select Bank MDR" (keypress)="onlyNumbersAllowed($event)"
                      (focus)="fun('surcharge')" (focusout)="funover('surcharge')">
                      <option value="" disabled class="drop" title="Select Bank MDR">Select Surcharge</option>
                      <option value="true" title="Yes">Yes</option>
                      <option value="false" title="No">No</option>
                    </select>

                    
                     <div *ngIf="isForm1Submitted && form1.surcharge.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  
                  </div>
                </div>
              </div>
            </ng-template>

          </ngb-panel>

          <!-- Kept by Radhe for future use for Reseller stuff-->

          <ngb-panel id="pan-4" title="Reseller Setup" *ngIf="this.resellerResponse">
            <ng-template ngbPanelContent>


              <div class="row">

                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label"> Reseller MDR Type <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>

                    <select (change)="resetMDR('resellerMdrType')" class="form-select"
                      aria-label="Default select example" formControlName="resellerMdrType" id="resellerMdrType"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.resellerMdrType.errors}"
                      title="Select Reseller MDR"  (focus)="fun('resellerMdrType')" (focusout)="funover('resellerMdrType')">
                      <option value="" disabled class="drop" title="Select Reseller MDR">Select Reseller MDR</option>
                      <option value="1" title="Percentage">Percentage</option>
                      <option value="2" title="Flat">Flat</option>
                    </select>
                     <div *ngIf="isForm1Submitted && form1.mdrType.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                     <!-- <ng-select [items]="MDRType"
                        [searchable]="false"
                        [(ngModel)]="selectedMDRType">
                      </ng-select>  -->
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">Reseller MDR <span aria-hidden="true" class="symbol required"
                        style="color:red;">*</span></label>
                    <input #resellerMdr type="text" autocomplete="new-password" class="form-control" placeholder="Reseller MDR"
                      formControlName="resellerMdr"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.resellerMdr.errors}" appTwoDigitDecimaNumber
                       (keypress)="onlyNumbersAllowed($event)" maxlength="10">


                     <div *ngIf="isForm1Submitted && form1.resellerMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>


                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">Minimum Reseller MDR</label>
                    <input #minResellerMdr type="text" autocomplete="new-password" class="form-control" placeholder="Min Reseller MDR"
                      formControlName="minResellerMdr"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.minResellerMdr.errors}"
                      appTwoDigitDecimaNumber
                      (keypress)="onlyNumbersAllowed($event)" maxlength="10">
                     <div *ngIf="isForm1Submitted && form1.minResellerMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>
                
                <div class="col-sm-4">
                  <div class="mb-3">
                    <label class="form-label">Maximum Reseller MDR</label>
                    <input #maxResellerMdr id="percent" maxlength="10" type="text" autocomplete="new-password" class="form-control"
                      placeholder="Max Reseller MDR" formControlName="maxResellerMdr"
                      [ngClass]="{'is-invalid': isForm1Submitted && form1.maxResellerMdr.errors}"
                      appTwoDigitDecimaNumber
                       (keypress)="onlyNumbersAllowed($event)" maxlength="10">

                     <div *ngIf="isForm1Submitted && form1.maxResellerMdr.errors?.required"
                        class="invalid-feedback">
                        Please fill this field
                    </div> 
                  </div>
                </div>
              </div>


            </ng-template>

          </ngb-panel>


        </ngb-accordion>


      </div>
      <div class="row mb-2">
        <div class="col-md-8"></div>
        <div class="col-md-2">
        
          <button type="button" class="form-control btn btn-danger pull-right mt-3" (click)="reset()"
            [disabled]="!(this.permissions.includes('Add') || this.permissions.includes('Edit'))">Reset
          </button>
        
        </div>
        <div class="col-md-2">
       
          <button type="submit" class="form-control btn btn-primary pull-right mt-3"
            [disabled]="!(this.permissions.includes('Add') || this.permissions.includes('Edit'))||this.loading">
            <span  id="loading" role="status" aria-hidden="true"></span>
            Submit
          </button>
 
        </div>
      </div>
    </form>

  </div>
</div>

<div class="row">
  <div class="col-xl-10 main-content">
    <button (click)="onExportCSV()" class="btn btn-light" type="button">Export CSV<i class="feather icon-download"></i>
    </button>

    <div class="btn-group" ngbDropdown role="group">
      <button class="btn btn-primary" ngbDropdownToggle>Columns</button>
      <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
        style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
        <div class="form-group">
        
          <div *ngIf="columnDefs" class="list-group ng-option">
            <span *ngFor="let column of columnDefs; let i = index" class="checkbox">
              <label class="list-group-item p-2">
                <input class="form-check-input me-1" type="checkbox" value="{{i}}" name="{{column.headerName}}"
                  (change)="updateSelectedTimeslots($event)"
                  [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')">
                {{column?.field?.replace('_',' ')?.replace('_',' ')?.replace('_',' ') | uppercase }}
                <span aria-hidden="true" class="symbol required" style="color:red;">*</span></label>
            </span>
          </div>

        </div>


      </div>
    </div>



  </div>
  
</div>

<div class="row" style="min-height: 300px">
  <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
    <ag-grid-angular [enableCellTextSelection]=true (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
      (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
      (rowDoubleClicked)="onRowDoubleClicked($event)" [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"
      [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
      [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
      style="width: 100%; height: auto;">
    </ag-grid-angular>
  </div>
</div>


<div class="row bg-white p-2 mt-0">
  <div class="col-md-4">
    <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
      class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
      <option [ngValue]="10">10</option>
      <option [ngValue]="20">20</option>
      <option [ngValue]="30">30</option>
    </select>
  </div>

  <div class="col-md-8">
    <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
      [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
      class="d-flex justify-content-end col-8 align-right">
    </ngb-pagination>
  </div>

</div>
